import { render } from "./Select.vue?vue&type=template&id=057fbf59&scoped=true&lang=pug"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=057fbf59&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-057fbf59"

export default script